import React, {useEffect, useState} from "react";

// Import your images (you can replace these with actual paths)

import mask2 from "../Accests/images/masks/masks.webp";
import mask3 from "../Accests/images/masks/Antic.jpg";
import mask4 from "../Accests/images/masks/antic1.jpg";
import BottomActionBar from "./BottomActionBar";
// import mask5 from "../Accests/images/masks/aa.png";


const MaskMuseum = () => {
    const images = [mask2,mask3,mask4];

    const [showActionBar, setShowActionBar] = useState(true);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (

        <>
            <BottomActionBar visible={showActionBar}/>
            <div className="w-full px-4 py-16 bg-white dark:bg-gray-900 mt-20 md:mt-14 lg:mt-10">
                <div className="max-w-6xl mx-auto text-center">
                    <h2 className="text-4xl font-bold text-gray-800 dark:text-white mb-4">
                        Mask Museum & Antiques
                    </h2>

                    <p className="text-gray-600 dark:text-gray-300 mb-10 max-w-2xl mx-auto">
                        Explore the rich history of traditional Sri Lankan masks and discover antique artifacts that
                        tell
                        stories of the past. Our collection features unique handcrafted pieces with cultural
                        significance.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {images.map((img, index) => (
                            <div key={index} className="overflow-hidden rounded-2xl shadow-lg">
                                <img
                                    src={img}
                                    alt={`Mask ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>

    );
};

export default MaskMuseum;
